import { Model } from "./model";
import { Time } from "./time";
import { Trade } from "./trade";

import { HasSocketEvent } from "@models/interfaces";
import { SocketEvent } from "@helpers/types";
import { FiatTransaction } from "@models/transaction";

export class SavingsPaymentsModel extends Model implements HasSocketEvent {
	private fiat_wallet_transaction: FiatTransaction = new FiatTransaction();
	private trade: Trade = new Trade();
	private recurring_at: Time = new Time();
	private created_at: Time = new Time();

	public eventData: SocketEvent = "";

	public getFiatTransaction(): FiatTransaction {
		return this.fiat_wallet_transaction;
	}

	public getTrade(): Trade {
		return this.trade;
	}

	public getRecurringAt(): Time {
		return this.recurring_at;
	}

	public getCreatedAt(): Time {
		return this.created_at;
	}

	public getEvent(): string {
		return this.eventData;
	}
}
